<template>
  <div>
    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-50" id="invalid_qq_music_versions">
        当前不兼容的QQ音乐版本
        <md-chips v-model="settings.invalidVersions" md-placeholder="添加一个..."></md-chips>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>输入适配的QQ音乐安装地址</label>
          <md-input v-model="settings.installUrl"></md-input>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-20">
        <md-button class="md-raised md-primary" @click="setInvalidVersions()">
          设置
        </md-button>
      </div>
    </div>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>

  </div>
</template>

<script>
export default {
  name: "QQMusic",
  data: () => ({
    settings: {
      invalidVersions: [],
      installUrl: ""
    },
    toast: false,
    toastMsg: "",
  }),

  mounted() {
    this.getInvalidVersions();
  },
  methods: {
    getInvalidVersions: function () {
      this.$http.get('/api/app/qq/music/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                let d = data.data;
                if (d) {
                  this.settings.invalidVersions = d.invalid_qq_music_versions;
                  this.settings.installUrl = d.install_url;
                }
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取列表失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    setInvalidVersions: function () {
      this.$http.post('/api/app/qq/music/', {
        invalid_qq_music_versions: this.settings.invalidVersions,
        install_url: this.settings.installUrl
      }).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('设置成功');
                this.getInvalidVersions();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取列表失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  }
}
</script>

<style scoped>
#invalid_qq_music_versions {
  text-align: left;
}
</style>